import { render, staticRenderFns } from "./ProductOptions.vue?vue&type=template&id=2f81fd76&scoped=true&"
import script from "./ProductOptions.vue?vue&type=script&lang=js&"
export * from "./ProductOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptions.vue?vue&type=style&index=0&id=2f81fd76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81fd76",
  null
  
)

export default component.exports